import { Stack } from '@mui/material';
import { ToggleButtonGroupContext } from '@/components/shared/toggle-button-group/context';
import { type ToggleButtonGroupProps } from '@/components/shared/toggle-button-group/interfaces';

export type { ToggleButtonGroupProps };

export const ToggleButtonGroup = <T,>({
  value,
  onChange,
  exclusive = true,
  children,
  ...stackProps
}: ToggleButtonGroupProps<T>) => {
  const handleChange = (buttonValue: unknown) => {
    if (exclusive) {
      onChange(buttonValue as T);
    } else {
      const currentValue = (value as unknown[]) || [];
      const newValue = currentValue.includes(buttonValue)
        ? currentValue.filter((v) => v !== buttonValue)
        : [...currentValue, buttonValue];
      onChange(newValue as T);
    }
  };

  return (
    <ToggleButtonGroupContext.Provider
      value={{ value, exclusive, onChange: handleChange }}
    >
      <Stack gap={2} {...stackProps}>
        {children}
      </Stack>
    </ToggleButtonGroupContext.Provider>
  );
};
